import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { getTimeBasedCollectionName } from './firebaseUtils';

// 기존 users 컬렉션을 시간 기반 컬렉션으로 마이그레이션
export const migrateUsersToTimeBasedCollections = async (): Promise<void> => {
  try {
    
    const usersRef = collection(db, 'users');
    const querySnapshot = await getDocs(usersRef);
    
    if (querySnapshot.empty) {
      return;
    }
    
    
    let successCount = 0;
    let errorCount = 0;
    
    for (const userDoc of querySnapshot.docs) {
      try {
        const userData = userDoc.data();
        
        // createdAt 필드가 있는 경우에만 마이그레이션
        if (userData.createdAt) {
          const createdAt = userData.createdAt.toDate ? userData.createdAt.toDate() : new Date(userData.createdAt);
          const collectionName = getTimeBasedCollectionName(createdAt);
          
          // 시간 기반 컬렉션에 사용자 추가
          await addDoc(collection(db, collectionName), {
            ...userData,
            migratedFrom: 'users',
            migratedAt: new Date()
          });
          
          // 기존 문서 삭제
          await deleteDoc(doc(db, 'users', userDoc.id));
          
          successCount++;
        } else {
          errorCount++;
        }
      } catch (error) {
        console.error(`사용자 ${userDoc.id} 마이그레이션 실패:`, error);
        errorCount++;
      }
    }
    
  } catch (error) {
    console.error('사용자 데이터 마이그레이션 중 오류 발생:', error);
    throw error;
  }
};

// 특정 사용자만 마이그레이션
export const migrateSingleUser = async (userId: string): Promise<boolean> => {
  try {
    const userDoc = await getDocs(collection(db, 'users'));
    const userData = userDoc.docs.find(doc => doc.id === userId)?.data();
    
    if (!userData) {
      return false;
    }
    
    if (!userData.createdAt) {
      return false;
    }
    
    const createdAt = userData.createdAt.toDate ? userData.createdAt.toDate() : new Date(userData.createdAt);
    const collectionName = getTimeBasedCollectionName(createdAt);
    
    // 시간 기반 컬렉션에 사용자 추가
    await addDoc(collection(db, collectionName), {
      ...userData,
      migratedFrom: 'users',
      migratedAt: new Date()
    });
    
    // 기존 문서 삭제
    await deleteDoc(doc(db, 'users', userId));
    
    return true;
  } catch (error) {
    console.error(`사용자 ${userId} 마이그레이션 실패:`, error);
    return false;
  }
};

// 마이그레이션 상태 확인
export const checkMigrationStatus = async (): Promise<{
  totalUsers: number;
  migratedUsers: number;
  remainingUsers: number;
}> => {
  try {
    const usersRef = collection(db, 'users');
    const querySnapshot = await getDocs(usersRef);
    
    const totalUsers = querySnapshot.size;
    const remainingUsers = totalUsers;
    
    // 시간 기반 컬렉션들의 총 사용자 수 계산
    // 실제 구현 시에는 모든 시간대 컬렉션을 검색해야 합니다
    const migratedUsers = 0; // 임시 값
    
    return {
      totalUsers,
      migratedUsers,
      remainingUsers
    };
  } catch (error) {
    console.error('마이그레이션 상태 확인 중 오류 발생:', error);
    throw error;
  }
};
